/* eslint-disable complexity */
import React from 'react';
import { bool, func, object } from 'prop-types';
import { t } from 'i18next';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import CustomButton from '~components/CustomButton';
import storePropTypes from '~constants/propTypes';
import { RENDER_CALL_CENTER } from '~constants/environment';
import { coreSettingsSelector } from '~screens/Dashboard/screens/Home/redux/selectors';

import styles from './styles.module.scss';

function StoreInfoContainer({ selectedStore, loading, onConfirm, isConfirmAddress, selectedTime }) {
  const coreSettings = useSelector(coreSettingsSelector);
  const { futureOrdersEnabled } = coreSettings;
  const timeNotSelected = futureOrdersEnabled && selectedStore && !selectedTime;
  const buttonText = isConfirmAddress ? t('Delivery:withConfirmAddressButton') : t('Delivery:confirmButton');
  return (
    <div
      className={cn('column middle center full-width', styles.container, {
        [styles.callCenterContainer]: RENDER_CALL_CENTER,
        [styles.containerWithWarning]: timeNotSelected
      })}>
      {timeNotSelected && (
        <span className={cn('m-top-2', styles.warningSelectTime)}>{t('Delivery:chooseATime')}</span>
      )}
      <CustomButton
        id="button-confirm-pickup"
        type="button"
        onClick={onConfirm}
        btnClassType="primary"
        fullWidth
        disabled={loading || !selectedStore || timeNotSelected || !selectedTime}>
        {loading ? <span className={styles.loading} /> : buttonText}
      </CustomButton>
    </div>
  );
}

StoreInfoContainer.propTypes = {
  isConfirmAddress: bool,
  loading: bool,
  selectedStore: storePropTypes,
  selectedTime: object,
  onConfirm: func
};

StoreInfoContainer.defaultProps = {};

export default StoreInfoContainer;
